module.exports = __webpack_public_path__ + "static/img/happy3.5da7d091.png";